import { CollectionResponse } from 'api/product';
import { SmartCollectionResponse } from 'api/product/getSmartCollection/types';
import { isSmartCollectionResponse } from 'api/product/getSmartCollection/utils';
import { SegmentationIds } from 'constants/segmentation';
import { ShopId } from 'constants/shop';
import { FormattedMessage } from 'react-intl';
import { CollectionProduct } from './collection';

interface transformResponseInput {
  title?: string;
  collection:
    | Omit<
        CollectionResponse,
        '_updatedAt' | '_updated' | 'sk' | 'pk' | 'missing' | 'handle' | 'published' | 'exportedAt'
      >
    | SmartCollectionResponse;
  shopId: ShopId;
}

export const transformCollection = ({ title, collection }: transformResponseInput): Collection => {
  return new Collection({
    title,
    collection,
  });
};

export class Collection {
  private bestSellerTitle?: string;
  public title: string;
  /** Title which should be used in endless cdp */
  public endlessCdpTitle?: string;
  public products: Array<CollectionProduct>;

  public getBestSellerTitle = ({
    segmentation,
  }: {
    segmentation?: SegmentationIds;
  }): React.ReactNode => {
    if (this.bestSellerTitle) {
      return this.bestSellerTitle;
    }

    if (segmentation) {
      return (
        <FormattedMessage
          id={`personalized-ribbon-${segmentation}`}
          values={{ b: (chunks) => <b>{chunks}</b> }}
        />
      );
    }

    return null;
  };

  constructor({
    title,
    collection,
  }: {
    title?: string;
    collection:
      | Omit<
          CollectionResponse,
          | '_updatedAt'
          | '_updated'
          | 'sk'
          | 'pk'
          | 'missing'
          | 'handle'
          | 'published'
          | 'exportedAt'
        >
      | SmartCollectionResponse;
  }) {
    this.products = (
      isSmartCollectionResponse(collection) ? collection.items : collection.products
    ).map((product) => new CollectionProduct(product));

    if (isSmartCollectionResponse(collection)) {
      this.bestSellerTitle = collection.title;
      this.endlessCdpTitle = collection.endless_title || collection.title || title;
    } else {
      this.endlessCdpTitle = title || collection.title;
    }
    this.title = title || collection.title;
  }
}
